<template>
  <div>
    <button @click="locClone()" class="btn btn-primary">Clone</button>
    <button @click="locDelete()" class="btn btn-danger">Delete</button> 
    
    <button data-close class="btn btn-secondary" style="float: right" @click="$emit('close')">
      Done
    </button>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "shared-clone-delete-item",
  props: ["section", "item"],
  methods: {
    ...mapActions("characters", ["cloneItem", "deleteItem"]),
    async locDelete() {
      let result = window.confirm(
        "Are you sure you want to delete " + this.item.name
      );
      if (result) {
        this.$emit("close");
        let payload = {
          section: this.section,
          item: this.item
        };
        await this.deleteItem(payload);
      }
    },
    async locClone() {
      this.$emit("close");
      let payload = {
        ruleset: this.ruleset,
        section: this.section,
        clone: this.item
      };
      let _vm = this;
      try {
        let item = await this.cloneItem(payload);
        _vm.$rpgv.toggleModal(_vm, `${_vm.section}-${item._id}`);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.btn {
  // margin: 0 !important;
  margin-top: 0.25em !important;
}
</style>
